import { isIndustryPageKey, type IndustryPageKey } from '../content/industryPages.js';

const previousTitles: Partial<Record<IndustryPageKey, readonly string[]>> = {
  "pflege": [
    "Pflege braucht Menschen mit Zukunft.",
    "Care needs people with a future.",
    "Bakımın geleceği insanla başlar."
  ],
  "einzelhandel": [
    "Menschen, die den Einzelhandel stärken.",
    "People who strengthen retail locations.",
    "Perakendeyi güçlendiren insanlar."
  ],
  "handwerk": [
    "Fachkräfte fürs Handwerk von morgen.",
    "Skilled people for tomorrow’s trades.",
    "Yarının zanaati için doğru çalışanlar."
  ],
  "gastro": [
    "Gastro-Teams, die Tempo mittragen.",
    "Hospitality teams that keep pace.",
    "Temponuza uyum sağlayan gastro ekipleri."
  ],
  "elektriker": [
    "Deine Zukunft als Elektriker oder Elektroniker.",
    "Your future in electrical & electronics work.",
    "Elektrik ve elektronikte geleceğin."
  ],
  "bauwesen": [
    "Bauwesen. Baue an deiner Zukunft.",
    "Construction. Build your future.",
    "İnşaat. Geleceğini sağlam temellerle kur."
  ],
  "schweisser": [
    "Schweißer. Dein Handwerk verbindet.",
    "Welding. Your craft makes connections.",
    "Kaynakçılık. Ustalığınla sağlam bağlar kur."
  ],
  "cnc": [
    "CNC-Zerspanung. Präzision mit Zukunft.",
    "CNC machining. Precision with a future.",
    "CNC ve talaşlı imalat. Hassasiyetle geleceğe."
  ],
  "shk": [
    "Deine Zukunft in Sanitär, Heizung & Klima.",
    "Your future in plumbing, heating & cooling.",
    "Sıhhi tesisat, ısıtma ve klimada geleceğin."
  ],
  "lkw-fahrer": [
    "LKW-Fahrer. Bring deine Zukunft auf die Straße.",
    "Truck driving. Take your future on the road.",
    "Kamyon şoförlüğü. Geleceğini yola çıkar."
  ]
};
const previousIntros: Partial<Record<IndustryPageKey, readonly string[]>> = {
  "pflege": [
    "Wir bringen Pflegeeinrichtungen mit internationalen Fachkräften zusammen. Sprache, Anerkennung und den Start im Team begleiten wir persönlich.",
    "We connect care providers with international professionals and personally support language preparation, recognition and the start in your team.",
    "Bakım kuruluşlarını uluslararası uzmanlarla buluşturuyoruz. Dil hazırlığı, denklik ve ekibe katılım sürecini kişisel destekle birlikte planlıyoruz."
  ],
  "einzelhandel": [
    "Ob Verkauf, Beratung oder Frischetheke: Wir unterstützen Sie bei der Suche nach internationalen Mitarbeitenden und begleiten den Einstieg in Ihr Team.",
    "From sales and customer service to fresh food counters, we help you find international staff and support their start in your team.",
    "Satış, müşteri danışmanlığı ve taze ürün reyonları için uluslararası çalışanlar bulmanıza ve ekibinize katılımlarını planlamanıza destek oluyoruz."
  ],
  "handwerk": [
    "Wir finden internationale Fachkräfte, die zu Ihrem Handwerksbetrieb passen. Qualifikation, Sprache und die Vorbereitung auf den Arbeitsalltag betrachten wir gemeinsam.",
    "We help you find international professionals for your trade business, considering their qualifications, language skills and preparation for everyday work.",
    "İşletmenize uygun uluslararası ustaları bulmanıza yardımcı oluyoruz. Mesleki yeterlilikleri, dil becerilerini ve işe hazırlık sürecini birlikte değerlendiriyoruz."
  ],
  "gastro": [
    "Für Küche und Service finden wir internationale Mitarbeitende, die zu Ihrem Betrieb passen. Aufgaben, Sprachkenntnisse und Teamalltag klären wir von Anfang an.",
    "We help you find international staff for kitchen and service roles, clarifying tasks, language skills and team expectations from the outset.",
    "Mutfak ve servis ekibiniz için uluslararası çalışanlar bulmanıza yardımcı oluyoruz. Görevleri, dil gereksinimlerini ve ekip beklentilerini baştan netleştiriyoruz."
  ],
  "elektriker": [
    "Du kennst dich mit Elektrik oder Elektronik aus? Wir schauen gemeinsam, wie deine Erfahrung zu einem Betrieb in Deutschland passt – von der ersten Bewerbung bis zum Ankommen.",
    "Experienced in electrical work or electronics? Together, we explore how your skills fit an employer in Germany, with personal guidance from your application through arrival.",
    "Elektrik veya elektronik alanında deneyimin mi var? Deneyiminin Almanya’daki bir işletmeyle nasıl örtüştüğünü birlikte değerlendiriyor, başvurudan varışa kadar sana eşlik ediyoruz."
  ],
  "bauwesen": [
    "Ob Tiefbau, Rohrbau, Kanalbau oder Trockenbau: Dein praktisches Können zählt. Wir bringen Struktur in deine Bewerbung und besprechen, welcher Betrieb und welche Aufgaben zu dir passen.",
    "Civil engineering, pipework, sewer construction or drywall: your practical skills matter. We help structure your application and discuss which tasks and employers fit your experience.",
    "Altyapı, boru döşeme, kanalizasyon veya alçıpan: pratik becerilerin önemli. Başvurunu birlikte yapılandırıyor, sana uygun işleri ve işletmeleri konuşuyoruz."
  ],
  "schweisser": [
    "Du arbeitest gern mit Metall und bringst Schweißerfahrung mit? Zeig uns, was du kannst. Wir begleiten dich auf dem Weg zu einem passenden Arbeitsplatz in Deutschland.",
    "Enjoy working with metal and have welding experience? Show us what you can do. We guide you towards a suitable workplace in Germany.",
    "Metalle çalışmayı seviyor ve kaynak deneyimi taşıyor musun? Becerilerini bize anlat. Almanya’da sana uygun bir işe giden yolda yanında olalım."
  ],
  "cnc": [
    "Drehen, Fräsen, Einrichten oder Programmieren: Erzähl uns von deiner Arbeit an CNC-Maschinen. Gemeinsam prüfen wir, wo dein Können in Deutschland gefragt ist.",
    "Turning, milling, setting up or programming: tell us about your CNC experience. Together, we explore where your skills could fit in Germany.",
    "Tornalama, frezeleme, makine ayarı veya programlama: CNC deneyimini bize anlat. Becerilerinin Almanya’da hangi işe uyabileceğini birlikte değerlendirelim."
  ],
  "shk": [
    "Wasser, Wärme, gutes Raumklima: Du hältst wichtige Technik am Laufen. Wir begleiten deine Bewerbung im Bereich Sanitär, Heizung und Klima für einen passenden Start in Deutschland.",
    "Water, warmth and a comfortable indoor climate: you keep essential systems running. We support your application in plumbing, heating and air conditioning for a suitable start in Germany.",
    "Su, sıcaklık ve iyi bir iç ortam: önemli sistemlerin çalışmasını sağlıyorsun. Sıhhi tesisat, ısıtma ve klima alanında Almanya’daki başlangıcın için başvuruna destek oluyoruz."
  ],
  "lkw-fahrer": [
    "Du hast Erfahrung am Steuer eines LKW? Wir besprechen mit dir, wie dein Weg in den Transport in Deutschland aussehen kann – mit klaren Anforderungen und persönlicher Begleitung.",
    "Have experience behind the wheel of a truck? We discuss your route into transport work in Germany with clear requirements and personal guidance.",
    "Kamyon kullanma deneyimin mi var? Almanya’da taşımacılık alanına giden yolunu, net gereklilikler ve kişisel destekle birlikte konuşalım."
  ]
};

export const isPreviousCompanyIndustryHeading = (key: string, title: string): boolean =>
  isIndustryPageKey(key) && (previousTitles[key]?.includes(title) ?? false);
export const isPreviousCompanyIndustryIntro = (key: string, intro: string): boolean =>
  isIndustryPageKey(key) && (previousIntros[key]?.includes(intro) ?? false);
